var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropDownInfoWrapper"},[_c('p',[_vm._v("Ändstoppet hindrar godset att ramla ner från armarna.")])])}]

export { render, staticRenderFns }